export const showSEODescription = false;